/* eslint-disable react/no-array-index-key */
import React from "react";
import { Helmet } from 'react-helmet-async';
import '../styles/main.css';
import '../styles/Domain.css';
import { ChevronRight, ExpandMore } from "@mui/icons-material";
import { Fade, Grow } from "@mui/material";
import { useParams, useSearchParams } from "react-router-dom";
import { domains, IDomain } from "../data/dataTypes";

const MainDomain = (
  // props
) => {
  const {type} = useParams();
  // const { params } = props.match;
  const intervention = domains.filter((dom: IDomain) => dom.type === type);
  console.log(type);


  return (
    <>
      <Helmet>
        <title>Isabelle PIVET - {intervention[0].title}</title>
      </Helmet>
      <div className="sectionMainDomain">
        <article className="domainArticle">
          <Fade in {... {timeout: 1000}}>
            <div style={{marginBottom: 30, textAlign: "center"}}>
              <h1 className='titleDomArticle'>
                Isabelle PIVET<br />{intervention[0].title}
              </h1>
              <ExpandMore fontSize="large" />
            </div>
          </Fade>
          <div className="domainDescription">
            {intervention[0].homeDescription.map((paragraph, index) => {
              return (
                <Grow key={index} in {... {timeout: 1500}}>
                  <div className="domainPart">
                    <div className="domainPartChild">
                      <h1 className="domainTitle">
                        <ChevronRight /> {paragraph.title !== "" ? paragraph.title : "Procédure"}
                      </h1>
                      <p className="textDomain" style={{textIndent: 20}}>{paragraph.description}</p>
                    </div>
                  </div>
                </Grow>
                );
              })}
          </div>
        </article>
      </div>
    </>
  );
};

export default MainDomain;
